import React, { Component, getGlobal } from "reactn";
import Spinner from "js/react/components/Spinner";
import teamsDS from "js/react/views/PresentationSettings/dataservices/TeamsDataService";
import { FetchStatus } from "js/react/constants";
import ErrorMessage from "js/react/components/ErrorMessage";
import permissionsDS from "../dataservices/PermissionsDataService";
import classNames from "classnames";
import log from "js/core/logger";
import { Icon } from "@material-ui/core";
import { FlexBox } from "js/react/components/LayoutGrid";
import styled from "styled-components";
import { TeamFoldersController, TeamFoldersDataService } from "js/core/dataServices/TeamFoldersDataService";
import { ds } from "js/core/models/dataService";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { AddPresentationToFolderDialog } from "js/editor/TeamResources/TeamFolderDialogs";
import ProgressDialog from "js/react/components/Dialogs/ProgressDialog";

const TeamFolderButton = styled.div`
  display: flex;
  colro: #333;
  padding: 6px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  align-items: center;
  .MuiIcon-root {
    margin-right: 6px;
  }
`;

class TeamFoldersList extends Component {
    async componentDidMount() {
        await teamsDS.fetchTeams(false);
    }

    state = {
        isAlreadyClicked: false
    };

    handleButtonClicked = async folderId => {
        if (this.state.isAlreadyClicked) return;
        this.setState({
            isAlreadyClicked: true
        });

        const presentation = getGlobal().presentation;

        //get team permissions
        const { permissions } = this.global.presentationPermissions;
        const teamsWithPermission = permissions.filter(perm => perm.level === "team");

        let folder = ds.teams.get(folderId);

        if (teamsWithPermission.find(team => team.id == folderId)) {
            let progressDialog = ShowDialog(ProgressDialog, {
                title: `Removing presentation from ${folder.get("name")}...`,
            });
            await TeamFoldersController.removePresentationFromTeamFolder(presentation, folderId);
            permissionsDS.fetchPermissions();
            progressDialog.props.closeDialog();
            this.setState({
                isAlreadyClicked: false
            });
        } else {
            ShowDialog(AddPresentationToFolderDialog, {
                folder, presentations: [{ presentationModel: presentation }],
                callback: () => {
                    this.setState({
                        isAlreadyClicked: false
                    });
                    permissionsDS.fetchPermissions();
                }
            });
        }
    }

    filterTeamsWithDisableProp = (allUserTeams, permissions) => {
        if (!allUserTeams || !permissions) return allUserTeams;
        //get team permissions
        const teamsWithPermission = permissions.filter(perm => perm.level === "team");
        //turn team permissions array into an object
        let teamsWithPermissionObj = {};
        teamsWithPermission.forEach(teamPerm => {
            teamsWithPermissionObj[teamPerm.id] = true;
        });

        return allUserTeams.map(userTeam => {
            userTeam.disabled = teamsWithPermissionObj[userTeam.id];
            return userTeam;
        });
    };

    render() {
        let { teams, status } = this.global.presentationTeams;
        const { permissions } = this.global.presentationPermissions;
        const updatedTeams = this.filterTeamsWithDisableProp(teams, permissions)
            .filter(team => team.get("orgId") == this.props.organizationId);

        switch (status.type) {
            case FetchStatus.ERROR:
                return <ErrorMessage title="An error occurred while loading teams" message={status.message} />;
            case FetchStatus.LOADING:
                return (
                    <div className="teams-list">
                        <Spinner />
                    </div>
                );
            case FetchStatus.SUCCESS:
                if (updatedTeams.length) {
                    return (
                        <div className="teams-list">
                            {updatedTeams &&
                                updatedTeams.map(team => {
                                    return (
                                        <TeamFolderButton key={team.id} className="team-folder-button" onClick={() => this.handleButtonClicked(team.id)}>
                                            <Icon>{team.disabled ? "check_box" : "check_box_outline_blank"}</Icon>
                                            {team.get("isDefault") ? "All Team Members" : team.get("name")}
                                        </TeamFolderButton>
                                    );
                                }).reverse()}
                        </div>
                    );
                } else {
                    return (
                        <div>
                            You are not a member of any teams.{" "}
                            <a href="https://beautifulai.zendesk.com/hc/en-us/sections/360006586871" rel="noreferer, ,noopener" target="_blank">
                                Learn more about creating and joining teams.
                            </a>
                        </div>
                    );
                }
        }
        return null;
    }
}

export default TeamFoldersList;
